import { render, staticRenderFns } from "./MessagePrompt.vue?vue&type=template&id=401ab4eb&"
import script from "./MessagePrompt.vue?vue&type=script&lang=js&"
export * from "./MessagePrompt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports